import { useQuery } from 'react-query'

import { documentService } from '../services'

export const useDocuments = (query = 'documents', retry = 0) =>
  useQuery(query, () => documentService.findDocuments(), {
    retry,
    refetchOnWindowFocus: false
  })
